import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import React from 'react';
import { RouteComponentProps } from 'react-router';

import MarketplacePageWrapper from './marketplace_page_wrapper';
import { EmptyShop } from '../discovery/empty_shop';

import { MarketplacePathContext } from '../shared/url_helpers';
import { CoreShopMarketplace } from '../../schemas/rql';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

type RouteProps = RouteComponentProps<MarketplacePathContext, {}>;

type Props = RouteProps & ChildProps<RouteProps, CoreShopMarketplace.Query, CoreShopMarketplace.Variables>;

export class ShopPage extends React.Component<Props, null> {
  renderEmptyShop() {
    if (!this.props.data.shop) {
      return null;
    }

    return (
      <EmptyShop
        shop={this.props.data.shop}
      />
    );
  }

  render() {
    const { showSold = false } = this.props.data.shop || {};

    return (
      <MarketplacePageWrapper
        emptyGrid={this.renderEmptyShop()}
        showSold={showSold}
        pageName={MParticlePageName.Shop}
      />
    );
  }
}

const connect = withGraphql<
RouteProps,
CoreShopMarketplace.Query,
CoreShopMarketplace.Variables
>(
  gql`
    query Core_Shop_Marketplace($shop: String) {
      shop(input: { slug: $shop }) {
        _id
        name
        id
        userId
        onVacation
        showSold
      }
    }
  `,
  {
    options: (props) => ({
      ssr: true,
      variables: {
        shop: props.params.shop,
      },
    }),
  },
);

export default connect(ShopPage);
